import React from "react";
import { styled } from "styled-components";

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 9px;
  margin-left: 10px;
  border-radius: 4px;
  background-color: var(--orange400, #ffa726);
  color: #1a1305;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  flex-shrink: 0;
`;

// Fails closed: only an explicit "staging" shows the marker, so a prod build (which never sets
// REACT_APP_ENV) can't render a stray badge.
const StagingBadge = () => {
  if (process.env.REACT_APP_ENV !== "staging") {
    return null;
  }
  return <Badge>STAGING</Badge>;
};

export default StagingBadge;
